import {Component, Input, OnInit} from '@angular/core';
import {AttributeModalEditData} from '../attribute-modal/attribute-modal-data';
import {EditMode} from '../../../core/edit-mode.enum';
import {MatDialog} from '@angular/material/dialog';
import {AttributeService} from '../attribute.service';
import {AttributeModalComponent} from '../attribute-modal/attribute-modal.component';
import {Attribute, AttributeSearchData} from '../attribute';
import {AuthInfo} from '../../../core/auth-info/auth-info';
import {AttributeState} from "../attribute-state.enum";
import {Paging, PagingHeader, PagingSort} from "../../../core/paging/paging";
import {debounceTime} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
  selector: 'app-attribute-overview',
  templateUrl: './attribute-overview.component.html',
  styleUrls: ['./attribute-overview.component.scss'],
})
export class AttributeOverviewComponent implements OnInit {
  @Input() authInfo!: AuthInfo;

  attributes: Attribute[] = [];
  paging: Paging = {
    currentPage: 0,
    pages: [],
    perPage: 20,
    sort: 'key',
    sortDirection: 'desc',
    totalItems: 0,
    totalPages: 0,
  };

  pagingSorts: PagingSort[] = [
    {key: 'key', direction: 'asc', displayName: 'Key (absteigend)'},
    {key: 'key', direction: 'desc', displayName: 'Key (aufsteigend)'},
  ];

  modelChanged = new Subject<string>();

  public filter: AttributeSearchData = {
    state: AttributeState.ACTIVE
  };

  constructor(
    private attributeService: AttributeService,
    private matDialog: MatDialog,
  ) {
    this.modelChanged
      .pipe(debounceTime(300))
      .subscribe(() => {
        this.search();
      });
  }

  public ngOnInit() {
    this.search();
  }

  searchChanged() {
    this.modelChanged.next();
  }

  search() {
    this.attributeService.search(this.filter, this.paging).then((pagesAttributes) => {
      this.updatePaging(pagesAttributes.pagingHeader);
      this.attributes = pagesAttributes.items;
    });
  }

  openCreateModal(event: MouseEvent) {
    const data: AttributeModalEditData = {
      editMode: EditMode.CREATE,
    };

    const dialogRef = this.matDialog.open(AttributeModalComponent, {
      width: '750px',
      maxWidth: '100%',
      minHeight: 'calc(100vh - 0)',
      // position: {top: '0', right: '0'},
      data,
    });
    dialogRef.afterClosed().subscribe((attribute?: Attribute) => {
      this.search();
    });
  }

  changeFilterState(filterState: string | null) {
    if (!filterState) {
      this.filter.state = null
    } else {
      this.filter.state = AttributeState[filterState as keyof typeof AttributeState];
    }

    this.search();
  }
  resetFilter() {
    this.filter.searchText = undefined;
    this.search();
  }
  openEditModal(attribute: Attribute, event: MouseEvent) {
    const data: AttributeModalEditData = {
      editMode: EditMode.EDIT,
      attributeId: attribute.id,
    };

    const dialogRef = this.matDialog.open(AttributeModalComponent, {
      width: '750px',
      maxWidth: '100%',
      minHeight: 'calc(100vh - 0)',
      // position: {top: '0', right: '0'},
      data,
    });
    dialogRef.afterClosed().subscribe((attribute?: Attribute) => {
      this.search();
    });
  }

  private updatePaging(pagingHeader: PagingHeader | undefined) {
    if (pagingHeader) {
      this.paging.perPage = pagingHeader.perPage;
      this.paging.totalItems = pagingHeader.totalItems;
      this.paging.currentPage = pagingHeader.currentPage;
      this.paging.totalPages = Math.ceil(pagingHeader.totalItems / pagingHeader.perPage);

      console.log('paging updated', this.paging);
      const pages: number[] = [];
      for (let i = 0; i < this.paging.totalPages; i++) {
        pages.push(i);
      }
      this.paging.pages = pages;
    }
  }
}
